export default __webpack_public_path__ + "static/media/sugar.f5e54e3b.svg";